define('modules/config',['require'],function(module) {
    return {
        cloudfrontUrl: '//sdk.touchcast.com',
        domain: '//www.touchcast.com',
        version: '1.0.0'
    }
});
